import React from "react";
import { GET_FILE_UPLOAD } from "api/ApiConstants";

const FlightTicketItinerary = (props) => {
  return (
    <>
      <div className="flex-box ticket-row ticket-itin-row">
        <div className="flex-box ticket-col carrier-identity-col">
          <img
            className="carrier-icon"
            src={
              GET_FILE_UPLOAD +
              "?fileName=" +
              props.dataItin?.flightName +
              ".png&type=AIRLINE_IMAGES"
            }
            alt={props.dataItin?.flightName + " icon"}
          />
          <div className="carrier-name-number">
            <p className="carrier-number">
              {props.dataItin?.flightName}-{props.dataItin?.flightCode}
            </p>
            <p className="carrier-name">{props.dataItin?.carrierName}</p>
          </div>
        </div>
        <div className="ticket-col itin-col">
          <div className="itin-container">
            <p className="airport-text">
              {props.dataItin?.departureStation}{" "}
              {props.dataItin?.departureDateTime.substring(16)}
            </p>
            <p className="date-text">
              {props.dataItin?.departureDateTime.substring(0, 16)}
            </p>
            <p className="airport-desc-text">
              {props.dataItin?.originCityName},{" "}
              {props.dataItin?.originAirportDesc}
            </p>
            <p className="terminal-text">
              Terminal{" "}
              {props.dataItin?.departureTerminal != ""
                ? props.dataItin?.departureTerminal
                : "__"}
            </p>
          </div>
        </div>
        <div className="ticket-col journey-duration-col">
          <p>
            <b>{props.dataItin?.journeyTime}</b>
          </p>
          <p>{props.casbinType}</p>
        </div>
        <div className="ticket-col itin-col">
          <div className="itin-container">
            <p className="airport-text">
              {props.dataItin?.arrivalStation}{" "}
              {props.dataItin?.arrivalDateTime.substring(16)}
            </p>
            <p className="date-text">
              {props.dataItin?.arrivalDateTime.substring(0, 16)}
            </p>
            <p className="airport-desc-text">
              {props.dataItin?.destinationCityName},{" "}
              {props.dataItin?.destinationAirpotDesc}
            </p>
            <p className="terminal-text">
              Terminal{" "}
              {props.dataItin?.arrivalTerminal != ""
                ? props.dataItin?.arrivalTerminal
                : "__"}
            </p>
          </div>
        </div>
      </div>
      <div className="flex-box ticket-row ticket-itin-row">
        <div className="flex-box ticket-col addon-info-col w100p itin-baggage-col">
          <p>
            <span className="add-on-label">Baggage Info - Check-in: </span>
            <span className="add-on-value">
              {props.dataItin?.flightBaggageInfo}
            </span>
          </p>
          <p>
            <span className="add-on-label">Cabin: </span>
            <span className="add-on-value">7 KG | {props.dataItin?.fareType}</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default FlightTicketItinerary;
